import request from '@/utils/request'

const userEmployees = {
  name: 'userEmployees',
  state: {
    isUserEmployeesDetailLoading: false,
    userEmployeesDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_USEREMPLOYEES_DETAIL_LOADING: (state, data) => {
      state.isUserEmployeesDetailLoading = data
    },
    SET_MODULES_USEREMPLOYEES_DETAIL_DATA: (state, data) => {
      state.userEmployeesDetailData = data
    }
  },

  actions: {
    //  获取账号编辑页面数据
    queryUserEmployeesDetailData({ commit }, id) {
      commit('SET_IS_MODULES_USEREMPLOYEES_DETAIL_LOADING', true)
      commit('SET_MODULES_USEREMPLOYEES_DETAIL_DATA', {})
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/userEmployees/userEmployeesDetail',
          method: 'post',
          data: { id: id }
        }).then(response => {
          commit('SET_IS_MODULES_USEREMPLOYEES_DETAIL_LOADING', false)
          commit('SET_MODULES_USEREMPLOYEES_DETAIL_DATA', response.data)
          resolve(response.data)
        }).catch(error => {
          commit('SET_IS_MODULES_USEREMPLOYEES_DETAIL_LOADING', false)
          reject(error)
        })
      })
    },
    //  重置账号新增页面数据
    resetUserEmployeesDetailData({ commit }) {
      commit('SET_MODULES_USEREMPLOYEES_DETAIL_DATA', {})
    },
    setUserEmployeesDetailData({ commit }, data) {
      commit('SET_MODULES_USEREMPLOYEES_DETAIL_DATA', data)
    }
  }
}

export default userEmployees
